/**
 * Utility for tracking UTM parameters in the application
 */

// List of UTM parameters to track
const UTM_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content'
];

// Storage key for UTM parameters
const UTM_STORAGE_KEY = 'fleek_utm_params';

/**
 * Captures UTM parameters from URL and stores them in localStorage
 */
const captureUTMParams = () => {
  const queryParams = getQueryParams();
  if (Object.keys(queryParams).length > 0) {
    localStorage.setItem('queryParams', JSON.stringify(queryParams));
  }

  // Parse URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = {};
  let hasUtmParams = false;

  // Extract UTM parameters from URL
  UTM_PARAMS.forEach(param => {
    if (urlParams.has(param)) {
      utmParams[param] = urlParams.get(param);
      hasUtmParams = true;
    }
  });

  // If UTM parameters exist in the URL, save them to localStorage
  if (hasUtmParams) {
    // Add timestamp for attribution window tracking
    utmParams.timestamp = Date.now();
    localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utmParams));
    console.log('UTM parameters captured:', utmParams);
  }
};

/**
 * Retrieves stored UTM parameters
 * @returns {Object|null} UTM parameters object or null if not available
 */
const getUTMParams = () => {
  const storedParams = localStorage.getItem(UTM_STORAGE_KEY);
  if (!storedParams) return null;
  
  try {
    return JSON.parse(storedParams);
  } catch (e) {
    console.error('Error parsing stored UTM parameters', e);
    return null;
  }
};

/**
 * Adds UTM parameters to any API request payload
 * @param {Object} payload - The original API request payload
 * @returns {Object} Updated payload with UTM parameters
 */
const addUTMParamsToPayload = (payload = {}) => {
  const utmParams = getUTMParams();
  if (!utmParams) return payload;

  return {
    ...payload,
    utm_data: utmParams
  };
};

/**
 * Clears stored UTM parameters
 */
const clearUTMParams = () => {
  localStorage.removeItem(UTM_STORAGE_KEY);
};

// Add these utility functions
const getQueryParams = () => {
  const params = new URLSearchParams(window.location.search);
  const queryParams = {};
  for (const [key, value] of params.entries()) {
    queryParams[key] = value;
  }
  return queryParams;
};

const appendQueryParams = (url) => {
  const storedParams = JSON.parse(localStorage.getItem('queryParams') || '{}');
  if (Object.keys(storedParams).length === 0) return url;

  const urlObj = new URL(url, window.location.origin);
  Object.entries(storedParams).forEach(([key, value]) => {
    if (!urlObj.searchParams.has(key)) {
      urlObj.searchParams.append(key, value);
    }
  });
  return urlObj.pathname + urlObj.search;
};

const navigateWithParams = (navigate, to) => {
  navigate(to);
};

export default {
  captureUTMParams,
  getUTMParams,
  addUTMParamsToPayload,
  clearUTMParams,
  appendQueryParams,
  navigateWithParams
}; 